import SingleProductCart from './SingleProductCart'

export default SingleProductCart
